module.exports = __webpack_public_path__ + "static/VanillaFlowers-c9a3ae2ae244eff728b2be1c27cfcdb4.jpg";